<div
  class="panel rs-bg-grey2 rs-panel-clickable jsrs-clickable rs-clickable"
  (click)="onClickOnTheCard()"
>
  <div class="rs-flex-row rs-flex-middle">
    <div class="rs-flex-column">
      <p
        class="rs-txt-s6 rs-font-pxB rs-no-padding-bottom"
        *ngIf="transactionConfiguration.title"
        data-cy="myBillTransactionCardHeaderTitle"
      >
        {{ transactionConfiguration.title }}
      </p>
      <div class="rs-flex-row rs-flex-top">
        <div class="rs-flex-column">
          <p data-cy="myBillTransactionCardHeaderInvoiceNumber">
            {{ transactionConfiguration.subtitle }}
          </p>
        </div>
        <div class="rs-flex-column rs-flex-shrink">
          <p class="rs-no-padding-bottom-m">
            <strong
              ><px-currency-amount
                [amount]="billingDocument.totalAmount"
              ></px-currency-amount></strong
            ><br />{{ 'bills.billCard.compactPriceText.vatIncl' | translate }}
          </p>
        </div>
      </div>
      <p
        class="{{ paymentTextColour }}"
        data-cy="myBillOpenTransactionPaymentStatus"
        *ngIf="paymentStatusDisplay.paymentText"
      >
        <i class="{{ warningIcon }}" *ngIf="warningIcon" aria-hidden="true"></i>
        {{ paymentStatusDisplay.paymentText }}
      </p>
    </div>
    <div class="rs-flex-column rs-flex-shrink">
      <span class="rs-panel-clickable-arrow" aria-hidden="true"></span>
    </div>
  </div>
</div>
